<template>
  <div class="time-selection-wrapper">
    <v-date-picker
      v-model="selectedDate"
      :locale="selectedLanguage.lang"
      :title-date-format=formatTitle
      :header-date-format=formatHeader
      :weekday-format=formatWeekday
      :day-format=formatDay
      :month-format=formatMonth
      :allowed-dates="allowedDates"
      :first-day-of-week=firstDayOfWeek
      :color="color"
      full-width
      :disabled="loading? true : false"
      class="date-picker time-selection-step"
      no-title
    ></v-date-picker>
    <div class="timeslots">
      {{availableTimeSlots.length === 0 && !loading ? messages.noTimeSlotsAvailable : ''}}
      <v-btn-toggle
        class="timeslot-content"
        v-model="selectedTime"
        v-for="(timeslot, index) in availableTimeSlots"
        :key="index"
        ref="timeTable"
      >
        <v-btn
          :disabled="loading || (timeslot.time === selectedTime ? true :false )"
          flat
          :ripple="false"
          class="timeslot"
          :value="timeslot.time"
          :id="'timebutton' + (index + 1)"
        >{{timeslot.time | formatTime(selectedLanguage)}}</v-btn>
      </v-btn-toggle>
    </div>
    <span
      role="log"
      aria-atomic="false"
      class="screen-reader-only"
      v-if="selectedDate && selectedTime"
    >{{messages.ariaDataSelected}}: {{selectedDate}}. {{selectedTime}}.
    </span>
    <v-alert
      role="alert"
      :value="timeSlotNotReserved"
      type="error"
    >{{ messages.errorTimeslotNotReserved}}</v-alert>
    <v-alert
      role="alert"
      :value="timeSlotSessionValidation"
      type="error"
    >{{ messages.errorTimeSlotSessionValidation}}</v-alert>
    <v-alert
      role="alert"
      :value="timeSlotInvalidNumberOfPeople"
      type="error"
    >{{ messages.errorTimeSlotInvalidNumberOfPeople}}</v-alert>
    <v-alert
      role="alert"
      :value="timeSlotGenericServerError"
      type="error"
    >{{ messages.errorGenericReserve}}</v-alert>
    <v-progress-linear role="progressbar" v-if="loading" class="progress-bar" :indeterminate="loading"></v-progress-linear>
  </div>
</template>

<script>
import RestService from '../services/restService'
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'TimeSelection',
  mixins: [RestService],
  props: [
    'reschedule'
  ],
  data: () => ({
    selectedDate: null,
    selectedTime: null,
    availableTimeSlots: [],
    availableDates: [],
    loading: false,
    color: '',
    reservedAppointmedId: null,
    timeSlotNotReserved: false,
    timeSlotSessionValidation: false,
    timeSlotInvalidNumberOfPeople: false,
    timeSlotGenericServerError: false
  }),
  computed: {
    ...mapState([
      'configuration',
      'selectedServices',
      'selectedBranch',
      'messages',
      'selectedLanguage',
      'funcDebug'
    ]),
    ...mapGetters({
      customSlotLength: 'customSlotLength',
      isBranchAndServicesValid: 'isBranchAndServicesValid'
    }),
    firstDayOfWeek () {
      return this.selectedLanguage.firstDayOfWeek ? this.selectedLanguage.firstDayOfWeek : '1'
    }
  },
  watch: {
    selectedServices (newData, oldData) {
      if (this.funcDebug) console.log('TimeSelection:watch:selectedServices')
      // if both services and branches selection valid then load
      if (this.isBranchAndServicesValid) {
        this.reloadDatesAndTimes()
      }
    },
    selectedBranch (newData, oldData) {
      if (this.funcDebug) console.log('TimeSelection:watch:selectedBranch')
      // if both services and branches selection valid then load
      if (this.isBranchAndServicesValid) {
        this.reloadDatesAndTimes()
      }
    },
    selectedDate (newDate, oldDate) {
      if (this.funcDebug) console.log('TimeSelection:watch:selectedDate')
      var _this = this
      this.loading = true
      if (this.reservedAppointmedId) {
        this.releaseTimeslot(this.reservedAppointmedId).then(response => {
          if (this.funcDebug) console.log('TimeSelection:watch:selectedDate:releaseTimeslot.then')
          _this.reservedAppointmedId = null
          _this.getTimeSlots()
          _this.$emit('timeslot-cleared')
        })
      } else {
        this.getTimeSlots()
      }
      this.selectedTime = null
      this.availableTimeSlots = []
    },
    loading () {
      var _this = this
      if (!this.loading && !this.selectedTime) {
        this.$nextTick(() => {
          if (_this.$refs.timeTable && _this.$refs.timeTable[0] && _this.$refs.timeTable[0].$children[0]) {
            _this.$refs.timeTable[0].$children[0].$el.focus()
          }
        })
      }
    },
    selectedTime (newTime, oldTime) {
      if (this.funcDebug) console.log('TimeSelection:watch:selectedTime')
      var _this = this
      if (newTime && oldTime && !this.reschedule && this.reservedAppointmedId) {
        this.loading = true
        this.releaseTimeslot(this.reservedAppointmedId).then(response => {
          if (this.funcDebug) console.log('TimeSelection:watch:selectedTime:releaseTimeslot.then')
          _this.reserveNewTimeslot()
        })
      } else if (newTime && !oldTime && !this.reschedule) {
        this.loading = true
        this.reserveNewTimeslot()
      } else if (this.reschedule) {
        _this.$emit('time-selected', _this.selectedTime, _this.selectedDate)
      }
    }
  },
  methods: {
    ...mapActions([
      'setCondTotalCost'
    ]),
    reloadDatesAndTimes () {
      if (this.funcDebug) console.log('TimeSelection:methods:reloadDatesAndTimes')
      var _this = this
      this.loading = true
      if (this.reservedAppointmedId) {
        _this.selectedTime = null
        this.releaseTimeslot(this.reservedAppointmedId).then(response => {
          if (this.funcDebug) console.log('TimeSelection:methods:reloadDatesAndTimes:releaseTimeslot.then')
          _this.reservedAppointmedId = null
          _this.$emit('timeslot-cleared')
          this.reloadDatesAndTimesStep2()
        })
      }
      this.reloadDatesAndTimesStep2()
    },
    reloadDatesAndTimesStep2 () {
      if (this.funcDebug) console.log('TimeSelection:methods:reloadDatesAndTimesStep2')
      var _this = this
      this.availableTimeSlots = []     
      this.getAvailableDates(this.selectedBranch.id, this.selectedServices, this.customSlotLength).then(response => {
        if (this.funcDebug) console.log('TimeSelection:methods:reloadDatesAndTimesStep2:getAvailableDates.then')
         this.availableDates = []
        for (var i = 0; i < response.data.length; i++) {
          var allowedDay = response.data[i]
          _this.availableDates.push(allowedDay.date)
        }
        _this.selectedDate = new Date().toISOString().slice(0, 10)
        _this.getTimeSlots()
      })
    },
    allowedDates (val) {
      return this.availableDates.indexOf(val) !== -1
    },
    getTimeSlots () {
      if (this.funcDebug) console.log('TimeSelection:methods:getTimeSlots')
      var _this = this     
      this.getAvailableTimes(this.selectedDate, this.selectedServices, this.customSlotLength, this.selectedBranch.id).then(response => {
        if (this.funcDebug) console.log('TimeSelection:methods:getTimeSlots:getAvailableTimes.then')
         _this.availableTimeSlots = []
        for (var i = 0; i < response.data.length; i++) {
          var timeSlot = {}
          timeSlot.time = response.data[i].time
          _this.availableTimeSlots.push(timeSlot)
        }
        _this.loading = false
        if (_this.$route.name === 'calendarbooking') {
          // this is the last unique action when both services and branches are preselected
          _this.$emit('is-loaded')
        }
      })
    },
    reserveNewTimeslot () {
      if (this.funcDebug) console.log('TimeSelection:methods:reserveNewTimeslot')
      var _this = this
      if (this.selectedTime) {
        this.reserveTimeSlot(this.selectedBranch, this.selectedDate, this.selectedTime, this.customSlotLength, this.selectedServices).then(response => {
          if (this.funcDebug) console.log('TimeSelection:methods:reserveNewTimeslot:reserveTimeSlot.then')
          if (response.data.errorMessage !== 'ERROR_CANNOT_BE_RESERVED' && response.data.errorMessage !== 'ERROR_SESSION_VIOLATION' &&
                response.data.errorMessage !== 'ERROR_INVALID_NUMBER_OF_PEOPLE' && response.data.errorMessage !== 'ERROR_GENERIC') {
            _this.reservedAppointmedId = response.data.publicId
            if (response.data.totalCost) {
              _this.setCondTotalCost(response.data.totalCost)
            }
            _this.timeSlotNotReserved = false
            _this.timeSlotSessionValidation = false
            _this.timeSlotInvalidNumberOfPeople = false
            _this.timeSlotGenericServerError = false
            _this.loading = false
            _this.$emit(
              'time-selected',
              _this.selectedTime,
              _this.selectedDate,
              _this.reservedAppointmedId
            )
          } else {
            if (response.data.errorMessage === 'ERROR_CANNOT_BE_RESERVED') {
              _this.timeSlotNotReserved = true
              _this.timeSlotSessionValidation = false
              _this.timeSlotInvalidNumberOfPeople = false
              _this.timeSlotGenericServerError = false
            } else if (response.data.errorMessage === 'ERROR_INVALID_NUMBER_OF_PEOPLE') {
              _this.timeSlotNotReserved = false
              _this.timeSlotSessionValidation = false
              _this.timeSlotInvalidNumberOfPeople = true
              _this.timeSlotGenericServerError = false
            } else if (response.data.errorMessage === 'ERROR_SESSION_VIOLATION') {
              _this.timeSlotNotReserved = false
              _this.timeSlotSessionValidation = true
              _this.timeSlotInvalidNumberOfPeople = false
              _this.timeSlotGenericServerError = false
            } else {
              _this.timeSlotNotReserved = false
              _this.timeSlotSessionValidation = false
              _this.timeSlotInvalidNumberOfPeople = false
              _this.timeSlotGenericServerError = true
            }
            _this.loading = false
            _this.selectedTime = null
          }
        })
      }
    },
    formatTitle (date) {
      moment.locale(this.selectedLanguage.lang)
      return moment(date).format('ddd DD MMM')
    },
    formatHeader (date) {
      moment.locale(this.selectedLanguage.lang)
      return moment(date).format('MMMM YYYY')
    },
    formatWeekday (date) {
      moment.locale(this.selectedLanguage.lang)
      var weekday = moment(date).format('ddd')
      return weekday.substring(0, 1).toUpperCase()
    },
    formatDay (date) {
      return moment(date).format('D')
    },
    formatMonth (date) {
      moment.locale(this.selectedLanguage.lang)
      return moment(date).format('MMM').substring(0, 3)
    }

  },
  mounted () {
    if (this.funcDebug) console.log('TimeSelection:mounted')
    // load Dates only if we branch and services valid
    if (this.isBranchAndServicesValid) {
      var _this = this
      this.loading = true
      this.getAvailableDates(this.selectedBranch.id, this.selectedServices, this.customSlotLength).then(response => {
        if (this.funcDebug) console.log('TimeSelection:mounted:getAvailableDates.then')
        for (var i = 0; i < response.data.length; i++) {
          var allowedDay = response.data[i]
          _this.availableDates.push(allowedDay.date)
        }
        _this.selectedDate = new Date().toISOString().slice(0, 10)
      })
    }
    var color = getComputedStyle(document.documentElement).getPropertyValue('--primary-color')
    color = color.substr(1)
    this.color = '#' + color.substr(1)
  }
}
</script>

<style>
.time-selection-wrapper .date-picker {
  margin: 0;
  border-bottom: 1px solid var(--input-border-color) !important;
  background-color: var(--wrapper-bg-color-secondary) !important;
  box-shadow: none;
}

.date-picker .v-picker__title {
  padding: 8px 0;
  border-bottom: 1px solid white;
}

.v-date-picker-table {
  padding: 16px;
  height: auto;
}

/*.v-picker__body {
  background-color: var(--wrapper-bg-color-primary) !important;
}*/

.date-picker .v-date-picker-title .v-picker__title__btn {
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  color: var(--btn-text-color) !important;
  display: block;
  margin: 0;
  padding: 0;
  line-height: 24px;
}

.v-picker__title__btn:not(.active) {
  opacity: 1;
}

.timeslot {
  border: 1px solid var(--input-border-color);
  background-color: var(--btn-bg-color) !important;
  color: var(--btn-text-color) !important;
  font-weight: 500;
  font-size: 16px;
  width: 70px;
}

.v-date-picker-table .v-btn {
  font-size: 16px;
}

.v-date-picker-table--date.time-selection-step .v-btn:hover,
.v-date-picker-table.v-date-picker-table--month.time-selection-step .v-btn:hover {
  height: 40px;
  width: 40px;
  color: var(--default-font-color) !important;
}

.v-date-picker-table--date .v-btn:hover{
  background-color: var(--charcoal-gre) !important;
}

.picker-reverse-transition-leave,
.picker-reverse-transition-leave-active,
.picker-reverse-transition-leave-to,
.picker-transition-leave,
.picker-transition-leave-active,
.picker-transition-leave-to {
  right: 0;
  left: 0;
}

.v-date-picker-table--date .v-btn.v-btn--active,
.v-date-picker-table.v-date-picker-table--month .v-btn.v-btn--active {
  color: var(--btn-text-color) !important;
  background-color: var(--focused-element) !important;
  border-color: var(--focused-element) !important;
}

.v-date-picker-header .v-btn.v-btn--icon .v-icon {
  font-size: 36px;
}

.theme--light.v-date-picker-table th {
  color: var(--default-font-color) !important;
  font-size: 16px;
  border-bottom: 1px solid #e5e9f0;
}

.timeslots {
  text-align: center;
  padding: 16px;
  background-color: var(--wrapper-bg-color-secondary) !important;
}

.timeslot-content {
  margin: 5px;
}

.timeslot-content.v-btn-toggle.v-btn-toggle--selected {
  box-shadow: none;
}

.timeslot-content.v-btn-toggle .v-btn {
  opacity: 1;
}
.timeslot-content.v-btn-toggle .v-btn:focus {
  border: 3px solid var(--focused-element) !important;
  background-color: var(--wrapper-bg-color-primary) !important;
  color: var(---default-font-color) !important;
}

.timeslot-content .timeslot.v-btn.v-btn--active {
  background-color: var(--focused-element) !important;
  color: var(--btn-text-color) !important;
  border-color: var(--focused-element) !important;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .time-selection-wrapper .v-date-picker-table--date .v-btn.v-btn--active,
  .time-selection-wrapper
    .v-date-picker-table.v-date-picker-table--month
    .v-btn.v-btn--active {
    color: var(--btn-text-color) !important;
    background-color: var(--focused-element) !important;
    border-color: var(--focused-element) !important;
  }
  .timeslot-content.v-btn-toggle .v-btn:focus {
    color: black !important;
  }
}
</style>
